import { DrawerCloseEvent, DrawerOpenEvent } from '@theme/theme-drawer';

function syncFilterTriggerAriaExpanded() {
  const drawer = document.getElementById('filters-drawer');
  const trigger = document.querySelector('[aria-controls="filters-drawer"]');
  if (!drawer || !trigger) return;
  trigger.setAttribute('aria-expanded', drawer.hasAttribute('open') ? 'true' : 'false');
}

/**
 * @param {Event} event
 */
function handleDrawerStateChange(event) {
  const target = event.target;
  if (!(target instanceof HTMLElement) || target.id !== 'filters-drawer') return;
  syncFilterTriggerAriaExpanded();
}

document.addEventListener(DrawerOpenEvent.eventName, handleDrawerStateChange);
document.addEventListener(DrawerCloseEvent.eventName, handleDrawerStateChange);
syncFilterTriggerAriaExpanded();
